import React, {FC} from 'react';
import classNames from 'classnames';
import {AsyncPaginate} from 'react-select-async-paginate';
import { TLabelAndValue } from '@/types';
import { api } from '@/api';
import styles from '../../styles/index.module.scss';
import {ISelect} from '../../interfaces';
import {customStyles} from './const';

const TypeTaskSelect: FC<ISelect> = ({onChangeSelect, classNameBlock,value}) => {
    const loadOptions = async () => {
        const response = await api.task.getTypesTask();
        const options: TLabelAndValue[] = response.map((el) => {
            return {
                value: el.value,
                label: el.label
            };
        });
        return {
            options
        };
    };

    return (
        <AsyncPaginate
            className={classNames(styles['item-select'], classNameBlock)}
            onChange={onChangeSelect}
            defaultValue={[value]}
            isClearable={false}
            placeholder='Выберите'
            loadOptions={loadOptions}
            styles={customStyles}
            noOptionsMessage={() => 'Ничего не найдено'}
            loadingMessage={() => 'Поиск...'}
        />
    );
};

export default TypeTaskSelect;